
export default {
    state: {
        province: "", // 省份名
        city: "", // 城市名
        adcode: "", // 区域编码
        weather: "", // 天气现象（汉字描述）
        temperature: "", // 实时气温，单位：摄氏度
        winddirection: "", // 风向描述
        windpower: "", // 风力级别，单位：级
        humidity: "", // 空气湿度
        reporttime: "" // 数据发布的时间
    },
    getters: {
    },
    mutations: {
        updateWeather(state, weather) {
            state.province = weather.province;
            state.city = weather.city;
            state.adcode = weather.adcode;
            state.weather = weather.weather;
            state.temperature = weather.temperature_float;
            state.winddirection = weather.winddirection;
            state.windpower = weather.windpower;
            state.humidity = weather.humidity_float;
            state.reporttime = weather.reporttime;
        },
    },
    actions: {
    },
    modules: {
    }
}
